import { render, staticRenderFns } from "./App-block-small.vue?vue&type=template&id=bc4268ae&scoped=true&"
import script from "./App-block-small.vue?vue&type=script&lang=ts&"
export * from "./App-block-small.vue?vue&type=script&lang=ts&"
import style0 from "./App-block-small.vue?vue&type=style&index=0&id=bc4268ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4268ae",
  null
  
)

export default component.exports